import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackEcomModalInternalEventData } from './legacy-types';

export const createLegacyTrackEcomModalInternalEvent = (
  vehicle: ElasticVehicle,
  information?: any,
): LegacyTrackEcomModalInternalEventData => {
  const eventData: LegacyTrackEcomModalInternalEventData = {
    eventType: 'ecomModalInternalEvent',
    item: vehicle,
    information: information,
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackEcomModalInternalEvent = () => {
  const { track } = useLegacyTracking();

  const trackLegacyEcomModalInternalEvent = useCallback(
    (vehicle: ElasticVehicle, information?: any) => {
      track({
        event: 'ecomModalInternalEvent',
        data: createLegacyTrackEcomModalInternalEvent(vehicle, information),
      });
    },
    [track],
  );

  return {
    trackLegacyEcomModalInternalEvent,
  };
};
